// oxlint-disable new-cap
// oxlint-disable-next-line no-named-as-default
import Axios, { type AxiosRequestConfig } from 'axios';
import { clearToken, getToken } from '../auth';

const AXIOS_INSTANCE = Axios.create({
  baseURL: import.meta.env.DEV ? '' : import.meta.env.VITE_API_BASE_URL || 'https://radius-proxy.race.com',
});

// Add Bearer token to requests
AXIOS_INSTANCE.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// Handle 401 responses by clearing auth and redirecting
AXIOS_INSTANCE.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearToken();
      const authUrl = import.meta?.env?.VITE_AUTH_URL;
      if (authUrl) {
        window.location.href = `${authUrl}?return=${encodeURIComponent(window.location.href)}`;
      }
    }

    return Promise.reject(error);
  },
);

// add a second `options` argument here if you want to pass extra options to each generated query
const axiosInstance = async <T>(config: AxiosRequestConfig, options?: AxiosRequestConfig): Promise<T> => {
  const { data } = await AXIOS_INSTANCE({
    ...config,
    ...options,
  });

  return data;
};

export { axiosInstance };
